import ApiConstants from '../constants/ApiConstants';
import http from "../http";
import Utility from '../utility/Utility';
export interface AttendanceSettingAPIConfig {
  params?: Object;
  queryParams?: Object;
}

const defaultConfig: AttendanceSettingAPIConfig = {
  params:{
      limit:20,
      currentPage:0,
      searchString: '',
      searchField: ''
  }
};

const defaultMappingConfig: AttendanceSettingAPIConfig = {
    params:{
        limit:20,
        currentPage:0,
        searchString: '',
        searchField: ''
    }
  };

class AttendanceSettingApiService {
  static apiConfig: AttendanceSettingAPIConfig;
  static apiMappingConfig: AttendanceSettingAPIConfig;
  static getAttendanceSetting() {
      const url = ApiConstants.URL.GEO_FENCING.GEO_LOCATION
      return http.get(url).catch(
          (error: any) => {
              console.error('Error loading attendance settings: ', error);
              return Promise.reject(error);
          }
      );
  }
  static getAttendanceSettingByPage() {
    if (Utility.isEmpty(this.apiConfig)) {
        this.apiConfig = defaultConfig;
    }

    return http.get(`${ApiConstants.URL.BASE}${ApiConstants.URL.GEO_FENCING.GEO_LOCATION}`, { params: this.apiConfig.params }).catch(
        (error) => {
            console.error('Error fetching locations by page: ', error);
            return Promise.reject(error);
        }
    );
  }
  
    static getLocationMapping() {
        const url = ApiConstants.URL.GEO_FENCING.GEO_LOCATION_MAPPING
        return http.get(url).catch(
            (error: any) => {
                console.error('Error loading attendance settings: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getLocationMappingByPage() {
        const url = ApiConstants.URL.GEO_FENCING.GEO_LOCATION_MAPPING;
        if (Utility.isEmpty(this.apiMappingConfig)) {
            this.apiMappingConfig = defaultMappingConfig;
        }
        return http.get(url,{ params: this.apiMappingConfig.params }).catch(
            (error: any) => {
                console.error('Error loading Mapping: ', error);
                return Promise.reject(error);
            }
        );
    }
  
  static saveAttendanceSetting(param, id){
      const url = ApiConstants.URL.GEO_FENCING.GEO_LOCATION ;
      if(id) {
          return http
          .put(
              `${url}`,param
          )
          .catch((err: any) => {
              console.error('Error save category: ', err);
              return Promise.reject(err);
          });
      } else {
          return http
          .post(
              url,param
          )
          .catch((err: any) => {
              console.error('Error save category: ', err);
              return Promise.reject(err);
          });
      }
  }

  static saveMapping(param, id){
    const url = ApiConstants.URL.GEO_FENCING.GEO_LOCATION_MAPPING ;
    if(id) {
        return http
        .put(
            `${url}`,param
        )
        .catch((err: any) => {
            console.error('Error save category: ', err);
            return Promise.reject(err);
        });
    } else {
        return http
        .post(
            url,param
        )
        .catch((err: any) => {
            console.error('Error save category: ', err);
            return Promise.reject(err);
        });
    }
}

  static deleteGeoLocation(param) {
    const url = ApiConstants.URL.GEO_FENCING.GEO_LOCATION;
    return http.delete(url,{data:param}).catch((err:any)=>{
        console.error('Error while delete category: ', err);
              return Promise.reject(err);
    })
  }
  static deleteGeoLocationMapping(param) {
    const url = ApiConstants.URL.GEO_FENCING.GEO_LOCATION_MAPPING;
    return http.delete(url,{data:param}).catch((err:any)=>{
        console.error('Error while delete category: ', err);
              return Promise.reject(err);
    })
  }
  static async getAddressFromLatLng(param) {
      const url = ApiConstants.URL.GEO_FENCING.GEO_CODE_REVERSE(param.lat,param.long,process.env.REACT_APP_GOOGLE_MAP_API_KEY);
      let response = await fetch(
              url
          )
          .catch((err: any) => {
              console.error('Error getting address ', err);
              return Promise.reject("");
          });
          const jsonData = await response.json();
          return jsonData
  }
  static getPlanForGeoLocation() {
    const url = ApiConstants.URL.GEO_FENCING.PLANS
    return http.get(url).catch(
        (error: any) => {
            console.error('Error loading Plan: ', error);
            return Promise.reject(error);
        }
    );
  }
}

export default AttendanceSettingApiService;
